import React from 'react';
import { Container, Heading } from '../../atoms';
import { ColumnInfoGroup, TeamCard } from '../../molecules';
export default function DepartmentsSectionDepartment(param) {
    var department = param.department;
    var _department_primaryMembers, _department_secondaryMembers;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3",
        className: "text-center mb-7 md:mb-8"
    }, department.title), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-9 sm:gap-10 md:gap-11"
    }, !!((_department_primaryMembers = department.primaryMembers) === null || _department_primaryMembers === void 0 ? void 0 : _department_primaryMembers.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center items-start flex-wrap -m-6"
    }, department.primaryMembers.map(function(member) {
        return /*#__PURE__*/ React.createElement("div", {
            key: member.name,
            className: "w-1/2 p-4 md:w-1/4 md:p-5"
        }, /*#__PURE__*/ React.createElement(TeamCard, {
            image: member.image,
            name: member.name,
            role: member.subtitle,
            action: member.action
        }));
    }))), !!((_department_secondaryMembers = department.secondaryMembers) === null || _department_secondaryMembers === void 0 ? void 0 : _department_secondaryMembers.length) && /*#__PURE__*/ React.createElement(Container, {
        containerClassName: "max-w-sm"
    }, /*#__PURE__*/ React.createElement(ColumnInfoGroup, {
        sortDirection: "vertical",
        entries: [
            {
                entries: department.secondaryMembers.map(function(entry) {
                    return {
                        title: entry.name,
                        subtitle: entry.subtitle,
                        action: entry.action
                    };
                })
            }
        ]
    }))));
}

//# sourceMappingURL=DepartmentsSectionDepartment.js.map